import moment from 'moment-timezone';

export const formatBalance = (
  value: number,
  showSymbol = true,
  maximumFractionDigits = 2,
) => {
  return `${showSymbol ? '$' : ''}${Intl.NumberFormat('nl-BE', {
    maximumFractionDigits: maximumFractionDigits,
  }).format(value)}`;
};

export const formatPrice = (
  value: number,
  showSymbol = true,
  precision = 4,
  lockPrecision?: boolean,
  signDisplay?: 'always' | 'never',
) => {
  return `${showSymbol ? '$' : ''}${Intl.NumberFormat('nl-BE', {
    ...(lockPrecision && { minimumFractionDigits: precision }),
    maximumFractionDigits: precision,
    signDisplay,
  }).format(value)}`;
};

export const formatNumber = (
  value: number,
  precision = 4,
  lockPrecision?: boolean,
) => {
  return `${Intl.NumberFormat('nl-BE', {
    ...(lockPrecision && { minimumFractionDigits: precision }),
    maximumFractionDigits: precision,
  }).format(value)}`;
};

export const formatPercentage = (
  value: number,
  precision = 2,
  lockPrecision?: boolean,
  signDisplay?: 'always' | 'never',
) => {
  return `${Intl.NumberFormat('nl-BE', {
    ...(lockPrecision && { minimumFractionDigits: precision }),
    maximumFractionDigits: precision,
    signDisplay,
  }).format(value * 100)}%`;
};

export const formatDate = (timestamp: number) => {
  const date = new Date(timestamp);
  const momentDate = moment(timestamp).utc();

  return `${momentDate.format(
    'DD MMM YYYY',
  )} ${date.getUTCHours()}:${date.getUTCMinutes()}`;
};
